import { authFetch } from "@/api/authFetch.ts"
import { API_BASE } from "@/config.ts"

import type { DataPointReport } from "../../types/reportTypes.ts"

export const getReport = async (id: number): Promise<DataPointReport> => {
  const res = await authFetch(`${API_BASE}/reports/${id}`)
  const data: DataPointReport = await res.json()
  if (data.range.$type == "constant") {
    data.range.start = new Date(data.range.start)
    data.range.end = new Date(data.range.end)
  }
  return data
}
